import { render, staticRenderFns } from "./cms-block-title.vue?vue&type=template&id=3fc3df1a&scoped=true"
import script from "./cms-block-title.vue?vue&type=script&lang=js"
export * from "./cms-block-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc3df1a",
  null
  
)

export default component.exports